module.exports = __webpack_public_path__ + "img/error_circle.3a40de70.svg";